export const links = {
    home: "/",
    blog: "/blog",
    contact: "/contact-us",
    faq: "/f_a_q_s",
    terms: "/terms-and-conditions",
    privacy: "/privacy",
    default: "/app",
    dashboard: "/dashboard",
    deposit: "/wallet/account/main/deposit/crypto",
    transactions: "/wallet/account/transactions",
    notifications: "/my/account/notifications",
    convert: "/function/convert",
    wallet: {
      default: "/wallet/account",
      overview: "/overview",
      main: "/main",
      withdraw: "/withdraw",
      spot: "/my/spot",
      funding: "/my/funding",
      nft: "/nfts",
      earn: "/earn",
      transfer: "/transfer",
      pexo: "/pexo-pay",
    },
    profile: "/profile",
    user: {
      referral: "/my/referral",
      setting: "/my/settings",
      security: "/my/security",
    },
    kyc: "/identification/kyc",
    identification: {
      step1: "/identification/kyc/step-1",
      apply: "/identification/kyc/apply",
    },
    market: {
      overview: "/markets/overview",
      trading: "/market/trading_data",
    },
    trade: {
      spot: "/trade/spot",
    },
  },
  marketApiURI =
    "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd",
  networkCoinsURI = `https://www.binance.com/bapi/capital/v1/public/capital/getNetworkCoinAll`,
  askAndBid = "https://www.binance.com/api/v3/depth?symbol=LUNAUSDT&limit=1000",
  popularApi =
    "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=10&page=1&sparkline=true",
  topGainersApi =
    "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=volume_desc&per_page=10&page=1&sparkline=true",
  topVolumeApi =
    "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=30&page=1&sparkline=true",
  authLinks = {
    default: "/auth",
    login: "/login",
    confirmed: "/confirmed",
    signUp: "/sign-up",
    otpVerify: "/otp-verification",
    forgotPassword: "/forgot-password",
  },
  navigation = [
    {
      name: "Market",
      href: null,
      hasChildren: true,
      children: [
        {
          name: "Markets Overview",
          href: links.default + links.market.overview,
          description:
            "Overview of the crypto market with real-time prices and key data",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="h-6 w-6"
            >
              <use xlinkHref="#market-overview-g" />
            </svg>
          ),
        },
        // {
        //   name: "Trading Data",
        //   href: links.default + links.market.trading,
        //   description: "View top market movers and price performance",
        //   icon: (
        //     <svg
        //       xmlns="http://www.w3.org/2000/svg"
        //       fill="currentColor"
        //       className="h-6 w-6"
        //     >
        //       <use xlinkHref="#trading-data-g" />
        //     </svg>
        //   ),
        // },
      ],
    },
    {
      name: "Trade",
      href: null,
      hasChildren: true,
      children: [
        {
          name: "Spot",
          href: links.default + links.trade.spot,
          description: "Trade crypto with advanced tools",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="h-6 w-6"
            >
              <use xlinkHref="#spot-g" />
            </svg>
          ),
        },
      ],
    },
  ],
  navigationRight = [
    {
      name: "Wallet",
      href: null,
      hasChildren: true,
      children: [
        {
          name: "Overview",
          href: links.default + links.wallet.default + links.wallet.overview,
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="h-4 w-4"
            >
              <use xlinkHref="#list-grid-f" />
            </svg>
          ),
        },
        {
          name: "Fiat and Spot",
          href: links.default + links.wallet.default + links.wallet.spot,
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="h-4 w-4"
            >
              <use xlinkHref="#spot-f" />
            </svg>
          ),
        },
        {
          name: "Transaction History",
          href: links.default + links.market.trading,
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="h-4 w-4"
            >
              <use xlinkHref="#transaction-history-f" />
            </svg>
          ),
        },
      ],
    },
  ],
  profileLinks = [
    {
      name: "My Profile",
      href: links.default + links.profile,
      icon: (
        <svg
          width={24}
          height={24}
          className="h-4 w-4 transition-colors"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5041 0C10.1669 0 9.83456 -2.32528e-05 9.51552 0.0952143C9.3298 0.0952143 9.14885 0.190522 8.96981 0.285759C8.90028 0.285759 8.82981 0.285736 8.76124 0.380973H8.68314C8.51457 0.476211 8.34886 0.571495 8.18886 0.666732H8.11076C8.0641 0.76197 8.02696 0.761924 7.98124 0.857161C7.85077 0.952399 7.71362 0.952445 7.59077 1.14292C7.47934 1.23816 7.38315 1.33333 7.27839 1.42856C6.92496 1.80951 6.6182 2.19051 6.36839 2.6667C5.93935 3.33336 5.61906 4.1905 5.48392 5.04764H5.30183C4.86469 5.23811 4.75707 6.00003 5.04173 6.85717C5.20878 7.4286 5.48678 7.8095 5.77011 7.99998C6.15068 9.52378 6.95687 10.7618 8.00695 11.5237V12.3809L7.17458 13.1428L5.50992 14C4.16374 14.6666 2.8227 15.3333 1.47804 16C0.732807 16.3809 0.444523 17.3332 0.51557 18.0951C0.550237 18.6666 0.361952 19.3332 0.879663 19.6189C1.37157 19.9046 1.95842 19.7142 2.49251 19.7142H7.17458H13.8336C15.8041 19.7142 17.7688 19.8095 19.7393 19.7142C20.3783 19.7142 20.5555 19.0475 20.4935 18.4761C20.505 17.7142 20.5507 16.857 19.9469 16.2856C19.4545 15.8094 18.7536 15.619 18.1526 15.238C17.2698 14.8571 16.3812 14.3809 15.4993 14L13.8336 13.1428L13.0012 12.3809V11.5237C14.0517 10.7618 14.8583 9.52378 15.2383 7.99998C15.5221 7.8095 15.8002 7.4286 15.9669 6.85717C16.2517 6.00003 16.144 5.23811 15.7069 5.04764H15.525C15.3898 4.1905 15.0698 3.33336 14.6402 2.6667C14.3907 2.19051 14.0841 1.80951 13.7298 1.42856C13.625 1.33333 13.5298 1.23816 13.4174 1.14292H13.3917C13.066 0.857208 12.7031 0.571448 12.325 0.380973C12.2298 0.380973 12.1374 0.285759 12.0393 0.285759C11.9698 0.285759 11.9022 0.190545 11.8307 0.190545C11.6184 0.0953073 11.4022 0.0952375 11.1803 0H11.1288H10.5041Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      name: "Security",
      href: links.default + links.user.security,
      icon: (
        <svg
          width={24}
          height={24}
          className="h-4 w-4 transition-colors"
          viewBox="0 0 20 23"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.96587 0.324707C13.6946 2.68842 17.064 3.80704 19.9551 3.54226C20.1827 8.14978 19.5398 11.9061 18.1524 14.8729C17.7964 14.5811 17.4019 14.3399 16.98 14.156C18.1008 11.6715 18.6163 8.5476 18.4277 4.73484C15.98 4.95848 13.1278 4.01186 9.97068 2.01051C7.23935 4.13265 4.42005 4.7541 1.54648 4.60355C1.41912 9.45702 2.27209 13.1109 3.91938 15.7692C5.13734 14.7508 7.21178 14.9048 8.19385 13.5542C8.26431 13.4496 8.29713 13.3936 8.2967 13.3472C8.29582 13.3236 7.2306 12.0172 7.13519 11.8649C6.88398 11.4658 6.41395 10.924 6.41395 10.4562C6.41395 10.1923 6.62227 9.84784 6.92031 9.77125C6.89711 9.37562 6.88136 8.9743 6.88136 8.57692C6.88136 8.34191 6.88617 8.10427 6.89448 7.87144C6.90761 7.72395 6.93475 7.65874 6.9737 7.51651C7.15742 6.91893 7.55716 6.41122 8.09494 6.09242C8.28532 5.97206 8.49232 5.87885 8.70414 5.80226C9.08883 5.66177 8.9024 5.05389 9.32472 5.0447C10.3112 5.01931 11.9344 5.88191 12.5668 6.56682C12.9699 7.01278 13.1996 7.50819 13.2136 8.10864L13.1734 9.8369C13.3484 9.87979 13.5449 10.0172 13.5878 10.1923C13.723 10.738 13.1567 11.4172 12.8937 11.8505C12.6513 12.2509 11.7239 13.3437 11.723 13.3525C11.7186 13.3998 11.7427 13.4584 11.8062 13.5542C12.0451 13.882 12.348 14.121 12.6871 14.3101C12.238 14.5454 11.827 14.8475 11.4683 15.2059C10.5659 16.1083 10.0074 17.3561 10.0074 18.7338C10.0074 19.9106 10.4171 20.9933 11.1011 21.8472C10.7449 22.0108 10.3794 22.164 10.0044 22.3049C3.54957 19.9487 -0.268432 14.1766 0.0147232 3.38734C3.40865 3.56546 6.73912 2.83153 9.96587 0.324707Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.9965 14.7495C17.1966 14.7495 18.9804 16.5333 18.9804 18.7338C18.9804 20.9343 17.1966 22.7181 14.9965 22.7181C12.796 22.7181 11.0122 20.9343 11.0122 18.7338C11.0122 16.5333 12.796 14.7495 14.9965 14.7495ZM14.0206 18.8769C14.1418 18.9798 14.2561 19.0904 14.3628 19.2082C14.6976 18.6695 15.0547 18.1745 15.432 17.7194C16.4981 16.4318 16.0149 16.68 17.4937 16.68L17.288 16.9084C16.6569 17.61 16.4438 17.9749 15.9261 18.7229C15.4134 19.4646 14.9484 20.2382 14.5339 21.0389L14.4061 21.2862L14.288 21.0341C14.0713 20.568 13.8109 20.1404 13.5006 19.7579C13.1908 19.3758 12.9195 19.1264 12.4989 18.8375C12.6919 18.2047 13.6092 18.5286 14.0206 18.8769Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      name: "Identification",
      href: links.default + links.kyc,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          className="h-4 w-4"
        >
          <use xlinkHref="#id-f" />
        </svg>
      ),
    },
    {
      name: "Referral",
      href: links.default + links.user.referral,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          className="h-4 w-4"
        >
          <use xlinkHref="#referral-f" />
        </svg>
      ),
    },
  ],
  walletLinks = [
    {
      name: "Overview",
      href: links.default + links.wallet.default + links.wallet.overview,
      link: true,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          className="group-hover:text-amber-500"
          width="21"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 4v7h7V4H4zm9 7V4h7v7h-7zm3.5 9.743L12.257 16.5l4.243-4.243 4.243 4.243-4.243 4.243zM4 13h7v7H4v-7z"
            fill="currentColor"
            // fill="#FFA800"
          />
        </svg>
      ),
    },
    {
      name: "Fiat and Spot",
      href: links.default + links.wallet.default + links.wallet.spot,
      link: true,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          width="21"
          height="20"
          className="group-hover:text-amber-500"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 3.5a5.502 5.502 0 00-5.302 4.032 7.502 7.502 0 016.77 6.77A5.502 5.502 0 0015 3.5zM14.5 15a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-8 0L9 17.5l2.5-2.5L9 12.5 6.5 15zM9 4H4v5l5-5zm11 16h-5l5-5v5z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      name: "Earn",
      href: links.default + links.user.referral,
      link: true,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          width={21}
          height={20}
          className="group-hover:text-amber-500"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.014 1a4.912 4.912 0 00-4.218 7.431 6.703 6.703 0 00-4.006 5.717H2v1.786h1.915a6.704 6.704 0 002.758 4.155l-1.648 1.648L6.287 23l2.07-2.07a6.694 6.694 0 002.118.342h5.304l1.591 1.591 1.263-1.262-1.34-1.34 4.35-4.35v-2.687h-1.934a6.126 6.126 0 00-1.398-2.915l2.435-2.435h-4.228A4.912 4.912 0 0012.014 1zM8.888 5.912a3.126 3.126 0 116.251 0 3.126 3.126 0 01-6.251 0zm1.786 0l1.34-1.34 1.34 1.34-1.34 1.34-1.34-1.34zm-.926 7.322h4.53v-1.786h-4.53v1.786z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      name: "Funding",
      href: links.default + links.wallet.default + links.wallet.funding,
      link: true,
      icon: (
        <svg
          width={21}
          height={20}
          className="group-hover:text-amber-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-4l4 4-4 4-4-4 4-4z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      name: "Share Pexo App",
      link: false,
      href: links.default + links.user.referral,
      icon: (
        <svg
          width={20}
          height={20}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 group-hover:text-amber-500"
        >
          <g clipPath="url(#clip0_8_1513)">
            <path
              d="M15.9167 19.9896C13.9167 19.9896 12.3334 18.4062 12.25 16.4063L6.16671 13.3229C5.50004 13.8229 4.83337 13.9896 4.00004 13.9896C2.00004 13.9896 0.333374 12.3229 0.333374 10.3229C0.333374 8.32292 2.00004 6.65625 4.00004 6.65625C4.75004 6.65625 5.50004 6.90625 6.16671 7.32292L12.25 4.23958C12.25 2.23958 13.9167 0.65625 15.9167 0.65625C17.9167 0.65625 19.5834 2.32292 19.5834 4.32292C19.5834 6.32292 17.9167 7.98958 15.9167 7.98958C15.1667 7.98958 14.4167 7.73958 13.75 7.32292L7.83337 10.4062L13.8334 13.4062C14.4167 12.9896 15.1667 12.7396 16 12.7396C18 12.7396 19.6667 14.4063 19.6667 16.4063C19.5834 18.3229 17.9167 19.9896 15.9167 19.9896Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_8_1513">
              <rect
                width={20}
                height={20}
                fill="currentColor"
                transform="translate(0 0.40625)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "Transaction History",
      href: links.default + links.transactions,
      link: true,
      icon: (
        <svg
          width="21"
          height="20"
          className="group-hover:text-amber-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.597 16.594A6.48 6.48 0 0112 18.498h-1.25v2.5H12a9 9 0 006.364-15.364 9 9 0 00-12.728 0l1.767 1.768a6.5 6.5 0 019.193 9.192zM13.25 8h-2.5v4.518l3.185 3.185 1.768-1.768-2.453-2.453V8zM5.627 9.568v1.2l-.092.006c-.767.062-1.371.29-1.783.662-.41.37-.639.891-.639 1.564 0 .684.24 1.223.676 1.642.438.421 1.08.726 1.889.925l.076.019v1.901l-.123-.029a3.94 3.94 0 01-.838-.305 2.512 2.512 0 01-.596-.4L3.14 17.935c.446.416 1.309.784 2.268.974l.08.016v1.277h1.578v-1.207l.086-.011c.796-.11 1.357-.448 1.718-.891a2.457 2.457 0 00.532-1.562c0-.669-.246-1.177-.668-1.568-.426-.394-1.037-.675-1.772-.874l-.074-.02v-1.802l.125.033c.406.106.816.31 1.099.558l1.035-1.136c-.43-.4-1.102-.697-1.875-.861l-.08-.017V9.568H5.628zm.19 4.272l-.137-.056c-.221-.09-.381-.185-.485-.303a.599.599 0 01-.149-.418c0-.133.028-.298.126-.448.1-.152.265-.279.522-.34l.123-.03v1.595zm1.057 3.678v-1.732l.147.08a.934.934 0 01.376.346.936.936 0 01.122.483.9.9 0 01-.096.429.744.744 0 01-.414.343l-.135.05z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      name: "Verification",
      href: links.default + links.kyc,
      link: true,
      icon: (
        <svg
          width="21"
          height="20"
          className="group-hover:text-amber-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 3v18h14V7l-4-4H5zm3 6.5h8V12H8V9.5zm0 5h8V17H8v-2.5z"
            fill="currentColor"
          />
        </svg>
      ),
    },
  ],
  dashboardLinks = [
    {
      name: "Profile",
      href: links.default + links.profile,
      link: true,
      icon: (
        <svg
          viewBox="0 0 21 20"
          fill="none"
          width="21"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5041 0C10.1669 0 9.83456 -2.32528e-05 9.51552 0.0952143C9.3298 0.0952143 9.14885 0.190522 8.96981 0.285759C8.90028 0.285759 8.82981 0.285736 8.76124 0.380973H8.68314C8.51457 0.476211 8.34886 0.571495 8.18886 0.666732H8.11076C8.0641 0.76197 8.02696 0.761924 7.98124 0.857161C7.85077 0.952399 7.71362 0.952445 7.59077 1.14292C7.47934 1.23816 7.38315 1.33333 7.27839 1.42856C6.92496 1.80951 6.6182 2.19051 6.36839 2.6667C5.93935 3.33336 5.61906 4.1905 5.48392 5.04764H5.30183C4.86469 5.23811 4.75707 6.00003 5.04173 6.85717C5.20878 7.4286 5.48678 7.8095 5.77011 7.99998C6.15068 9.52378 6.95687 10.7618 8.00695 11.5237V12.3809L7.17458 13.1428L5.50992 14C4.16374 14.6666 2.8227 15.3333 1.47804 16C0.732807 16.3809 0.444523 17.3332 0.51557 18.0951C0.550237 18.6666 0.361952 19.3332 0.879663 19.6189C1.37157 19.9046 1.95842 19.7142 2.49251 19.7142H7.17458H13.8336C15.8041 19.7142 17.7688 19.8095 19.7393 19.7142C20.3783 19.7142 20.5555 19.0475 20.4935 18.4761C20.505 17.7142 20.5507 16.857 19.9469 16.2856C19.4545 15.8094 18.7536 15.619 18.1526 15.238C17.2698 14.8571 16.3812 14.3809 15.4993 14L13.8336 13.1428L13.0012 12.3809V11.5237C14.0517 10.7618 14.8583 9.52378 15.2383 7.99998C15.5221 7.8095 15.8002 7.4286 15.9669 6.85717C16.2517 6.00003 16.144 5.23811 15.7069 5.04764H15.525C15.3898 4.1905 15.0698 3.33336 14.6402 2.6667C14.3907 2.19051 14.0841 1.80951 13.7298 1.42856C13.625 1.33333 13.5298 1.23816 13.4174 1.14292H13.3917C13.066 0.857208 12.7031 0.571448 12.325 0.380973C12.2298 0.380973 12.1374 0.285759 12.0393 0.285759C11.9698 0.285759 11.9022 0.190545 11.8307 0.190545C11.6184 0.0953073 11.4022 0.0952375 11.1803 0H11.1288H10.5041Z"
            fill="#FFA800"
          />
        </svg>
      ),
    },
    {
      name: "Referral",
      href: links.default + links.user.referral,
      link: true,
      icon: (
        <svg
          // className="h-7 w-7"
          viewBox="0 0 24 24"
          fill="none"
          width="21"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth={0} />
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="SVGRepo_iconCarrier">
            <path
              d="M1.5 6.5C1.5 3.46243 3.96243 1 7 1C10.0376 1 12.5 3.46243 12.5 6.5C12.5 9.53757 10.0376 12 7 12C3.96243 12 1.5 9.53757 1.5 6.5Z"
              fill="#FFA800"
            />
            <path
              d="M14.4999 6.5C14.4999 8.00034 14.0593 9.39779 13.3005 10.57C14.2774 11.4585 15.5754 12 16.9999 12C20.0375 12 22.4999 9.53757 22.4999 6.5C22.4999 3.46243 20.0375 1 16.9999 1C15.5754 1 14.2774 1.54153 13.3005 2.42996C14.0593 3.60221 14.4999 4.99966 14.4999 6.5Z"
              fill="#FFA800"
              fillOpacity="0.3"
            />
            <path
              d="M0 18C0 15.7909 1.79086 14 4 14H10C12.2091 14 14 15.7909 14 18V22C14 22.5523 13.5523 23 13 23H1C0.447716 23 0 22.5523 0 22V18Z"
              fill="#FFA800"
            />
            <path
              d="M16 18V23H23C23.5522 23 24 22.5523 24 22V18C24 15.7909 22.2091 14 20 14H14.4722C15.4222 15.0615 16 16.4633 16 18Z"
              fill="#FFA800"
              fillOpacity="0.3"
            />
          </g>
        </svg>
      ),
    },
    // {
    //   name: "Rewards Center",
    //   href: links.default + links.user.referral,
    //   link: true,
    //   icon: (
    //     <svg
    //       width={20}
    //       height={27}
    //       viewBox="0 0 20 27"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         fillRule="evenodd"
    //         clipRule="evenodd"
    //         d="M3.42579 0.00332361C5.08071 0.00332361 6.49319 0.0244054 6.56698 0.0560281C6.63023 0.0771099 8.15866 1.97447 13.2288 8.43604H14.1248C14.9048 8.43604 15.0524 8.46767 15.2632 8.67848C15.4951 8.91039 15.5057 8.95255 15.4951 13.4957L15.9905 14.1492C16.2646 14.5181 16.6441 15.119 16.8233 15.4984C17.013 15.8779 17.2449 16.4893 17.3503 16.8688C17.4874 17.3642 17.5401 17.9123 17.5401 18.8715C17.5401 20.01 17.4979 20.3051 17.2555 21.0324C17.0973 21.4962 16.8022 22.1814 16.5808 22.5609C16.3595 22.9298 15.8219 23.6044 15.3897 24.0471C14.947 24.4898 14.2724 25.038 13.8613 25.2804C13.4607 25.5123 12.8283 25.8074 12.4593 25.9234C12.101 26.0499 11.4369 26.1975 10.9836 26.2607C10.5409 26.324 9.81358 26.345 9.3814 26.3029C8.93868 26.2712 8.15866 26.0921 7.58945 25.9023C7.02024 25.702 6.27184 25.3542 5.8502 25.0801C5.4391 24.8061 4.82773 24.279 4.47988 23.8995C4.13203 23.5201 3.68931 22.9614 3.49958 22.6557C3.32038 22.3395 3.0147 21.6543 2.82496 21.1378C2.51927 20.2629 2.48765 20.0837 2.48765 18.8188C2.47711 17.6699 2.51927 17.322 2.71955 16.6579C2.85658 16.2258 3.13065 15.5617 3.33092 15.1822C3.52066 14.8027 3.87905 14.2757 4.53259 13.4957V11.1978C4.53259 8.97363 4.54313 8.89984 4.77503 8.66794C4.9226 8.52037 5.13342 8.43604 5.34424 8.43604C5.53397 8.43604 5.69209 8.41496 5.69209 8.38334C5.69209 8.35172 4.41664 6.70734 2.84604 4.71511C0.4638 1.68987 0 1.05741 0 0.762268C0 0.561991 0.0843272 0.340632 0.210818 0.214142C0.411095 0.0138645 0.558668 0.00332361 3.42579 0.00332361ZM6.21913 12.1254C7.2416 11.6405 7.84243 11.4191 8.2219 11.3137C8.66462 11.1978 9.29707 11.1345 10.0139 11.1345C10.836 11.1345 11.3315 11.1978 11.9323 11.3664C12.3856 11.4929 12.9864 11.7143 13.2815 11.8618L13.8086 12.1254V10.1226H6.21913V12.1254ZM8.88598 17.3431L5.11234 17.3958C7.39971 19.0402 8.07433 19.5462 8.09541 19.5883C8.11649 19.6305 7.88459 20.421 7.58945 21.3486C7.2943 22.2762 7.0624 23.0457 7.08348 23.0563C7.10457 23.0668 7.76864 22.6136 8.55921 22.0338L10.0139 20.9797C12.2591 22.603 12.9231 23.0668 12.9442 23.0563C12.9653 23.0457 12.765 22.2868 12.5015 21.3697C12.238 20.4632 12.0166 19.6832 12.0166 19.6305C12.0166 19.5883 12.6807 19.0824 13.4818 18.5026L14.947 17.4485L11.2471 17.3431C10.3617 14.729 10.0982 13.9595 10.0876 13.9384C10.0771 13.9173 9.7925 14.6763 9.47627 15.6249L8.88598 17.3431ZM16.5281 0.00332361C19.5323 -0.00721729 19.5534 -0.0072173 19.7853 0.235223C19.9539 0.403878 20.0172 0.572532 19.9961 0.814973C19.975 1.06795 19.3636 1.92177 17.3925 4.4305C15.3159 7.06573 14.7783 7.68764 14.6835 7.57169C14.6097 7.4979 13.7664 6.42273 11.0679 2.95478L12.0799 1.65824C12.6385 0.952005 13.1867 0.287928 13.3026 0.182519C13.4924 0.0244054 13.8086 0.00332361 16.5281 0.00332361Z"
    //         fill="#FFA800"
    //       />
    //     </svg>
    //   ),
    // },
    {
      name: "KYC",
      href: links.default + links.kyc,
      link: true,
      icon: (
        <svg
          width={20}
          height={21}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_158_8296)">
            <path
              d="M10.075 8.44971C10.2408 8.44971 10.3998 8.51556 10.517 8.63277C10.6342 8.74998 10.7 8.90895 10.7 9.07471V10.0447C10.6999 11.5379 10.4671 13.0219 10.01 14.4435L8.34629 19.6185C8.29257 19.7723 8.18088 19.8991 8.03504 19.9718C7.88919 20.0445 7.72072 20.0573 7.56554 20.0076C7.41035 19.9579 7.28072 19.8495 7.20427 19.7056C7.12782 19.5617 7.11061 19.3936 7.15629 19.2372L8.81879 14.061C9.2361 12.7631 9.44865 11.4081 9.44879 10.0447V9.07471C9.44879 8.90895 9.51464 8.74998 9.63185 8.63277C9.74906 8.51556 9.90803 8.44971 10.0738 8.44971H10.075Z"
              fill="#FFA800"
            />
            <path
              d="M7.57497 9.07471C7.57497 8.7464 7.63963 8.42131 7.76527 8.118C7.8909 7.81468 8.07505 7.53909 8.3072 7.30694C8.53935 7.07479 8.81494 6.89064 9.11826 6.76501C9.42157 6.63937 9.74666 6.57471 10.075 6.57471C10.4033 6.57471 10.7284 6.63937 11.0317 6.76501C11.335 6.89064 11.6106 7.07479 11.8427 7.30694C12.0749 7.53909 12.259 7.81468 12.3847 8.118C12.5103 8.42131 12.575 8.7464 12.575 9.07471C12.575 9.24047 12.5091 9.39944 12.3919 9.51665C12.2747 9.63386 12.1157 9.69971 11.95 9.69971C11.7842 9.69971 11.6252 9.63386 11.508 9.51665C11.3908 9.39944 11.325 9.24047 11.325 9.07471C11.325 8.74319 11.1933 8.42524 10.9589 8.19082C10.7244 7.9564 10.4065 7.82471 10.075 7.82471C9.74345 7.82471 9.4255 7.9564 9.19108 8.19082C8.95666 8.42524 8.82497 8.74319 8.82497 9.07471V9.48971C8.82497 10.001 8.79747 10.5097 8.74247 11.016C8.72084 11.1774 8.63707 11.3239 8.50899 11.4245C8.38092 11.5251 8.21865 11.5717 8.05673 11.5544C7.89481 11.5371 7.74602 11.4574 7.64203 11.3321C7.53805 11.2067 7.48707 11.0458 7.49997 10.8835C7.54997 10.421 7.57497 9.95596 7.57497 9.48971V9.07471ZM11.9612 10.3247C12.0433 10.3268 12.1242 10.3451 12.1992 10.3784C12.2742 10.4118 12.3419 10.4596 12.3985 10.5192C12.455 10.5787 12.4992 10.6489 12.5287 10.7255C12.5581 10.8022 12.5721 10.8839 12.57 10.966C12.5329 12.3858 12.2857 13.7923 11.8362 15.1397L10.2537 19.8897C10.2012 20.047 10.0883 20.177 9.9399 20.2511C9.79151 20.3252 9.61977 20.3373 9.46247 20.2847C9.30516 20.2322 9.17517 20.1193 9.10109 19.9709C9.02702 19.8225 9.01492 19.6508 9.06747 19.4935L10.6512 14.7435C11.0611 13.5135 11.2864 12.2295 11.32 10.9335C11.3221 10.8514 11.3403 10.7705 11.3737 10.6955C11.4071 10.6205 11.4549 10.5527 11.5145 10.4962C11.574 10.4397 11.6441 10.3954 11.7208 10.366C11.7974 10.3366 11.8791 10.3225 11.9612 10.3247ZM7.76622 12.9685C7.84472 12.9927 7.91767 13.0322 7.9809 13.0846C8.04413 13.1371 8.09639 13.2015 8.1347 13.2742C8.17302 13.3469 8.19663 13.4264 8.20418 13.5082C8.21173 13.59 8.20308 13.6725 8.17872 13.751L6.54997 18.9985C6.52688 19.0783 6.48812 19.1527 6.43594 19.2173C6.38377 19.2819 6.31923 19.3355 6.2461 19.375C6.17297 19.4144 6.09272 19.4388 6.01004 19.4468C5.92736 19.4549 5.8439 19.4463 5.76455 19.4218C5.6852 19.3972 5.61155 19.357 5.54791 19.3036C5.48426 19.2502 5.4319 19.1847 5.39388 19.1108C5.35586 19.0369 5.33295 18.9562 5.32648 18.8734C5.32001 18.7906 5.33012 18.7073 5.35622 18.6285L6.98497 13.3797C7.03419 13.2217 7.14409 13.0896 7.29055 13.0125C7.43702 12.9354 7.60808 12.9196 7.76622 12.9685Z"
              fill="#FFA800"
            />
            <path
              d="M5.94871 7.61585C6.29393 6.64412 6.97121 5.82551 7.8611 5.30442C8.75099 4.78333 9.79631 4.59323 10.8127 4.76766C11.8291 4.94208 12.7512 5.46983 13.4164 6.25781C14.0816 7.04579 14.4472 8.04337 14.4487 9.0746C14.4487 9.24036 14.3829 9.39933 14.2657 9.51654C14.1484 9.63375 13.9895 9.6996 13.8237 9.6996C13.6579 9.6996 13.499 9.63375 13.3818 9.51654C13.2646 9.39933 13.1987 9.24036 13.1987 9.0746C13.1986 8.33748 12.9379 7.62412 12.4627 7.0606C11.9876 6.49708 11.3285 6.11967 10.602 5.99507C9.87543 5.87047 9.12826 6.0067 8.49246 6.37968C7.85667 6.75267 7.37319 7.33839 7.12746 8.03335C7.0721 8.18966 6.9569 8.31758 6.80723 8.38896C6.65755 8.46034 6.48565 8.46934 6.32933 8.41398C6.17302 8.35861 6.04511 8.24342 5.97373 8.09375C5.90234 7.94407 5.89335 7.77217 5.94871 7.61585ZM6.32371 9.70335C6.48862 9.71948 6.64038 9.80043 6.74563 9.92841C6.85087 10.0564 6.90099 10.2209 6.88496 10.3859C6.80058 11.2463 6.63313 12.0965 6.38496 12.9246L4.85746 18.0146C4.80989 18.1734 4.70118 18.3068 4.55525 18.3854C4.40933 18.4641 4.23813 18.4816 4.07933 18.434C3.92054 18.3864 3.78714 18.2777 3.70849 18.1318C3.62984 17.9858 3.61239 17.8147 3.65996 17.6559L5.18746 12.5659C5.41265 11.8148 5.56461 11.0437 5.64121 10.2634C5.65733 10.0984 5.73829 9.94668 5.86627 9.84143C5.99425 9.73619 6.15879 9.68732 6.32371 9.70335ZM13.8237 10.5121C13.9895 10.5121 14.1484 10.578 14.2657 10.6952C14.3829 10.8124 14.4487 10.9713 14.4487 11.1371C14.4487 12.7371 14.1825 14.3271 13.6587 15.8396L12.2962 19.7709C12.2369 19.9205 12.1221 20.0415 11.9757 20.1086C11.8294 20.1757 11.6628 20.1838 11.5106 20.1311C11.3585 20.0784 11.2326 19.969 11.1591 19.8257C11.0856 19.6825 11.0703 19.5164 11.1162 19.3621L12.4775 15.4309C12.955 14.0496 13.2 12.5984 13.2 11.1371C13.2 10.9713 13.2658 10.8124 13.383 10.6952C13.5002 10.578 13.6592 10.5121 13.825 10.5121H13.8237Z"
              fill="#FFA800"
            />
            <path
              d="M4.87752 5.60211C5.57196 4.56101 6.56318 3.75257 7.72263 3.28161C8.88209 2.81065 10.1563 2.6989 11.38 2.96086C11.4604 2.97793 11.5366 3.01066 11.6043 3.05718C11.672 3.10371 11.7299 3.16311 11.7746 3.232C11.8194 3.30089 11.8501 3.37791 11.8651 3.45868C11.88 3.53945 11.879 3.62238 11.8619 3.70273C11.8448 3.78309 11.8121 3.85929 11.7656 3.92699C11.7191 3.9947 11.6596 4.05257 11.5908 4.09732C11.5219 4.14207 11.4448 4.1728 11.3641 4.18778C11.2833 4.20276 11.2004 4.20168 11.12 4.18461C10.1408 3.97448 9.12107 4.06354 8.19313 4.44025C7.26519 4.81695 6.47192 5.4639 5.91627 6.29711C5.82279 6.4317 5.68018 6.5242 5.51916 6.55467C5.35814 6.58514 5.1916 6.55115 5.05539 6.46002C4.91919 6.36889 4.82423 6.22791 4.79096 6.06745C4.75769 5.90699 4.78878 5.73988 4.87752 5.60211ZM13.2775 4.40836C13.3858 4.28292 13.5394 4.2056 13.7047 4.19342C13.8699 4.18123 14.0333 4.23516 14.1588 4.34336C14.8389 4.92966 15.3845 5.65591 15.7582 6.47246C16.1318 7.28902 16.3247 8.17662 16.3238 9.07461V10.9496C16.3238 11.1154 16.2579 11.2743 16.1407 11.3916C16.0235 11.5088 15.8645 11.5746 15.6988 11.5746C15.533 11.5746 15.374 11.5088 15.2568 11.3916C15.1396 11.2743 15.0738 11.1154 15.0738 10.9496V9.07461C15.0746 8.35616 14.9203 7.64599 14.6213 6.99272C14.3223 6.33945 13.8856 5.75849 13.3413 5.28961C13.216 5.18117 13.1389 5.02743 13.127 4.86218C13.115 4.69693 13.1692 4.5337 13.2775 4.40836ZM4.60002 7.62711C4.6813 7.63904 4.75943 7.66687 4.82995 7.70902C4.90046 7.75117 4.96197 7.80681 5.01097 7.87275C5.05996 7.93869 5.09547 8.01365 5.11547 8.09333C5.13547 8.17301 5.13957 8.25585 5.12752 8.33711C5.09127 8.57711 5.07252 8.82461 5.07252 9.07461C5.07252 9.96211 4.94752 10.8459 4.70002 11.6996L3.27502 16.6034C3.25367 16.6839 3.21643 16.7594 3.16549 16.8253C3.11455 16.8912 3.05094 16.9463 2.9784 16.9873C2.90586 17.0283 2.82586 17.0544 2.7431 17.064C2.66034 17.0736 2.57648 17.0666 2.49647 17.0433C2.41647 17.0201 2.34191 16.9811 2.2772 16.9286C2.21249 16.8761 2.15893 16.8112 2.11966 16.7377C2.08039 16.6642 2.05621 16.5836 2.04855 16.5007C2.04088 16.4177 2.04988 16.334 2.07502 16.2546L3.50002 11.3509C3.71435 10.6111 3.82293 9.84477 3.82252 9.07461C3.82252 8.76211 3.84627 8.45461 3.89002 8.15461C3.90195 8.07333 3.92979 7.9952 3.97193 7.92468C4.01408 7.85417 4.06972 7.79266 4.13566 7.74367C4.20161 7.69467 4.27656 7.65916 4.35624 7.63916C4.43592 7.61916 4.51876 7.61507 4.60002 7.62711ZM15.7025 12.2021C15.8676 12.2161 16.0203 12.2951 16.1272 12.4216C16.2341 12.5482 16.2864 12.712 16.2725 12.8771C16.1675 14.1271 15.9 15.3596 15.4725 16.5446L14.5425 19.1296C14.4845 19.283 14.3686 19.4074 14.2197 19.4761C14.0708 19.5448 13.9009 19.5522 13.7466 19.4968C13.5923 19.4414 13.466 19.3275 13.3948 19.1798C13.3237 19.0321 13.3134 18.8623 13.3663 18.7071L14.2975 16.1196C14.6859 15.0404 14.9314 13.915 15.0275 12.7721C15.0415 12.607 15.1205 12.4543 15.247 12.3474C15.3736 12.2405 15.5374 12.1883 15.7025 12.2021Z"
              fill="#FFA800"
            />
            <path
              d="M6.01251 2.03727C7.24774 1.32411 8.64894 0.948685 10.0753 0.94873C11.5016 0.948776 12.9028 1.32429 14.138 2.03753C15.3731 2.75078 16.3988 3.77661 17.1119 5.01191C17.8249 6.24721 18.2002 7.64845 18.2 9.07477C18.2 9.24053 18.1342 9.3995 18.0169 9.51672C17.8997 9.63393 17.7408 9.69977 17.575 9.69977C17.4092 9.69977 17.2503 9.63393 17.1331 9.51672C17.0159 9.3995 16.95 9.24053 16.95 9.07477C16.9504 7.86776 16.633 6.68191 16.0298 5.63646C15.4266 4.591 14.5587 3.72279 13.5135 3.1191C12.4683 2.51542 11.2826 2.19755 10.0756 2.19745C8.86858 2.19735 7.68281 2.51502 6.63751 3.11852C6.49467 3.19324 6.32848 3.20989 6.17367 3.16497C6.01885 3.12006 5.88737 3.01706 5.8067 2.8775C5.72603 2.73794 5.7024 2.5726 5.74075 2.41603C5.7791 2.25945 5.87647 2.12375 6.01251 2.03727ZM4.90001 3.60852C4.96124 3.66319 5.0111 3.72937 5.04675 3.8033C5.08241 3.87724 5.10315 3.95747 5.10779 4.03942C5.11243 4.12137 5.10089 4.20343 5.07381 4.28091C5.04674 4.3584 5.00467 4.4298 4.95001 4.49102C3.82051 5.75032 3.19712 7.38315 3.20001 9.07477C3.20001 9.24053 3.13416 9.3995 3.01695 9.51672C2.89974 9.63393 2.74077 9.69977 2.57501 9.69977C2.40925 9.69977 2.25028 9.63393 2.13307 9.51672C2.01586 9.3995 1.95001 9.24053 1.95001 9.07477C1.95001 6.99477 2.73251 5.09477 4.01876 3.65852C4.07342 3.59729 4.13961 3.54743 4.21354 3.51178C4.28747 3.47613 4.3677 3.45539 4.44965 3.45074C4.5316 3.4461 4.61366 3.45764 4.69115 3.48472C4.76863 3.51179 4.83878 3.55386 4.90001 3.60852ZM2.39376 10.3498C2.55314 10.3946 2.6882 10.5009 2.76929 10.6453C2.85038 10.7897 2.87087 10.9603 2.82626 11.1198L1.85251 14.5785C1.83307 14.6605 1.79727 14.7376 1.74726 14.8054C1.69725 14.8732 1.63406 14.9301 1.56149 14.9728C1.48892 15.0156 1.40846 15.0432 1.32494 15.054C1.24143 15.0649 1.15658 15.0588 1.07549 15.036C0.994411 15.0133 0.918762 14.9743 0.853092 14.9216C0.787422 14.8689 0.733085 14.8034 0.693345 14.7292C0.653605 14.6549 0.629281 14.5734 0.621833 14.4895C0.614386 14.4056 0.623969 14.3211 0.650008 14.241L1.62251 10.7823C1.64472 10.7032 1.6823 10.6293 1.73309 10.5648C1.78387 10.5003 1.84688 10.4464 1.91851 10.4062C1.99013 10.366 2.06897 10.3404 2.15052 10.3307C2.23206 10.321 2.31472 10.3275 2.39376 10.3498ZM17.5813 10.951C17.6633 10.9526 17.7443 10.9704 17.8195 11.0033C17.8947 11.0363 17.9627 11.0837 18.0196 11.1429C18.0765 11.2021 18.1211 11.2719 18.151 11.3484C18.1809 11.4248 18.1954 11.5064 18.1938 11.5885C18.1563 13.4623 17.9925 15.3698 17.285 17.2548L17.1975 17.4885C17.1363 17.6395 17.0186 17.7606 16.8694 17.826C16.7202 17.8914 16.5514 17.896 16.3989 17.8388C16.2464 17.7816 16.1222 17.6672 16.0528 17.5198C15.9835 17.3724 15.9744 17.2038 16.0275 17.0498L16.115 16.816C16.7475 15.1285 16.9075 13.391 16.9438 11.5635C16.9454 11.4814 16.9632 11.4005 16.9961 11.3253C17.029 11.2501 17.0764 11.1821 17.1356 11.1252C17.1948 11.0683 17.2646 11.0237 17.3411 10.9938C17.4176 10.9639 17.4992 10.9494 17.5813 10.951Z"
              fill="#FFA800"
            />
          </g>
          <defs>
            <clipPath id="clip0_158_8296">
              <rect
                width={20}
                height={20}
                fill="white"
                transform="translate(0 0.324707)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "Security",
      href: links.default + links.user.security,
      link: true,
      icon: (
        <svg
          width={20}
          height={23}
          viewBox="0 0 20 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.96587 0.324707C13.6946 2.68842 17.064 3.80704 19.9551 3.54226C20.1827 8.14978 19.5398 11.9061 18.1524 14.8729C17.7964 14.5811 17.4019 14.3399 16.98 14.156C18.1008 11.6715 18.6163 8.5476 18.4277 4.73484C15.98 4.95848 13.1278 4.01186 9.97068 2.01051C7.23935 4.13265 4.42005 4.7541 1.54648 4.60355C1.41912 9.45702 2.27209 13.1109 3.91938 15.7692C5.13734 14.7508 7.21178 14.9048 8.19385 13.5542C8.26431 13.4496 8.29713 13.3936 8.2967 13.3472C8.29582 13.3236 7.2306 12.0172 7.13519 11.8649C6.88398 11.4658 6.41395 10.924 6.41395 10.4562C6.41395 10.1923 6.62227 9.84784 6.92031 9.77125C6.89711 9.37562 6.88136 8.9743 6.88136 8.57692C6.88136 8.34191 6.88617 8.10427 6.89448 7.87144C6.90761 7.72395 6.93475 7.65874 6.9737 7.51651C7.15742 6.91893 7.55716 6.41122 8.09494 6.09242C8.28532 5.97206 8.49232 5.87885 8.70414 5.80226C9.08883 5.66177 8.9024 5.05389 9.32472 5.0447C10.3112 5.01931 11.9344 5.88191 12.5668 6.56682C12.9699 7.01278 13.1996 7.50819 13.2136 8.10864L13.1734 9.8369C13.3484 9.87979 13.5449 10.0172 13.5878 10.1923C13.723 10.738 13.1567 11.4172 12.8937 11.8505C12.6513 12.2509 11.7239 13.3437 11.723 13.3525C11.7186 13.3998 11.7427 13.4584 11.8062 13.5542C12.0451 13.882 12.348 14.121 12.6871 14.3101C12.238 14.5454 11.827 14.8475 11.4683 15.2059C10.5659 16.1083 10.0074 17.3561 10.0074 18.7338C10.0074 19.9106 10.4171 20.9933 11.1011 21.8472C10.7449 22.0108 10.3794 22.164 10.0044 22.3049C3.54957 19.9487 -0.268432 14.1766 0.0147232 3.38734C3.40865 3.56546 6.73912 2.83153 9.96587 0.324707Z"
            fill="#FFA800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9965 14.7495C17.1966 14.7495 18.9804 16.5333 18.9804 18.7338C18.9804 20.9343 17.1966 22.7181 14.9965 22.7181C12.796 22.7181 11.0122 20.9343 11.0122 18.7338C11.0122 16.5333 12.796 14.7495 14.9965 14.7495ZM14.0206 18.8769C14.1418 18.9798 14.2561 19.0904 14.3628 19.2082C14.6976 18.6695 15.0547 18.1745 15.432 17.7194C16.4981 16.4318 16.0149 16.68 17.4937 16.68L17.288 16.9084C16.6569 17.61 16.4438 17.9749 15.9261 18.7229C15.4134 19.4646 14.9484 20.2382 14.5339 21.0389L14.4061 21.2862L14.288 21.0341C14.0713 20.568 13.8109 20.1404 13.5006 19.7579C13.1908 19.3758 12.9195 19.1264 12.4989 18.8375C12.6919 18.2047 13.6092 18.5286 14.0206 18.8769Z"
            fill="#FFA800"
          />
        </svg>
      ),
    },
    {
      name: "Settings",
      href: links.default + links.user.setting,
      link: true,
      icon: (
        <svg
          viewBox="0 0 24 24"
          width={23}
          height={23}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="text-white dark:text-pexo-gray-950"
        >
          <path
            fill="#FFA800"
            d="M2 12.947v-1.771c0-1.047.85-1.913 1.899-1.913 1.81 0 2.549-1.288 1.64-2.868a1.919 1.919 0 0 1 .699-2.607l1.729-.996c.79-.474 1.81-.192 2.279.603l.11.192c.9 1.58 2.379 1.58 3.288 0l.11-.192c.47-.795 1.49-1.077 2.279-.603l1.73.996a1.92 1.92 0 0 1 .699 2.607c-.91 1.58-.17 2.868 1.639 2.868 1.04 0 1.899.856 1.899 1.912v1.772c0 1.047-.85 1.912-1.9 1.912-1.808 0-2.548 1.288-1.638 2.869.52.915.21 2.083-.7 2.606l-1.729.997c-.79.473-1.81.191-2.279-.604l-.11-.191c-.9-1.58-2.379-1.58-3.288 0l-.11.19c-.47.796-1.49 1.078-2.279.605l-1.73-.997a1.919 1.919 0 0 1-.699-2.606c.91-1.58.17-2.869-1.639-2.869A1.911 1.911 0 0 1 2 12.947Z"
          />
          <path
            fill="currentColor"
            d="M11.995 15.332c1.794 0 3.248-1.464 3.248-3.27 0-1.807-1.454-3.272-3.248-3.272-1.794 0-3.248 1.465-3.248 3.271 0 1.807 1.454 3.271 3.248 3.271Z"
          />
        </svg>
      ),
    },
    // {
    //   name: "Gift Cards",
    //   href: links.default + links.user.referral,
    //   link: true,
    //   icon: (
    //     <svg
    //       width="20"
    //       height="16"
    //       viewBox="0 0 20 16"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         fill-rule="evenodd"
    //         clip-rule="evenodd"
    //         d="M10.982 0.495642C10.7466 0.592586 10.4146 0.766869 10.2442 0.882798C9.95066 1.0826 9.88624 1.09365 9.0188 1.09365C7.95279 1.09365 8.04367 0.962159 8.21655 2.25411L8.32493 3.06452L8.05682 3.48365L7.78863 3.90287L7.57637 3.75154C7.13335 3.43573 7.10013 3.35201 6.96047 2.19754L6.8268 1.09365H3.99961C1.37355 1.09365 1.15181 1.10415 0.88369 1.24171C0.518708 1.42883 0.285217 1.67851 0.131941 2.04536C-0.0287256 2.42987 -0.0499662 6.6188 0.108755 6.61623C0.162285 6.61537 0.427132 6.58269 0.697504 6.54356L1.18892 6.47252L1.49127 6.77487C1.65761 6.94122 1.97661 7.18171 2.20015 7.30939C2.56956 7.5204 2.5894 7.54514 2.41777 7.5807C2.21057 7.62364 0.243747 7.86266 0.0974737 7.86266C0.0290834 7.86266 0.0118885 8.64218 0.0283831 10.9943C0.0494682 13.9965 0.0570931 14.1388 0.212936 14.4372C0.302334 14.6083 0.524155 14.8534 0.705829 14.9818L1.03619 15.2152L4.79867 15.2375L8.56115 15.2598L8.5252 15.004C8.50544 14.8635 8.4011 14.0348 8.29335 13.1627C8.08109 11.4447 8.08039 11.4549 8.47191 10.5153L8.58231 10.2501L8.96021 10.8265L9.33803 11.4028L9.53768 13.0756C9.64746 13.9956 9.75654 14.8632 9.78012 15.0037L9.82283 15.2589L14.3638 15.2371L18.9048 15.2152L19.2304 14.9818C19.4095 14.8534 19.6028 14.6608 19.6599 14.5539C20.0188 13.8815 20.0026 14.1936 19.9987 8.01049C19.9966 4.80447 19.9665 2.19902 19.9316 2.22049C19.8968 2.24205 19.847 2.17506 19.8211 2.07165C19.752 1.79638 19.4083 1.41996 19.067 1.24583C18.7875 1.1033 18.5945 1.09365 16.012 1.09365H13.2553L12.8918 0.793245C12.2777 0.28588 11.7069 0.196871 10.982 0.495642ZM11.1337 1.44097C10.4019 1.82229 9.70231 2.60205 8.81946 4.02035L8.42647 4.65174L8.9024 4.70153C9.8268 4.79809 10.4074 5.259 10.6547 6.09252C10.7277 6.33847 10.8292 6.53982 10.88 6.5399C11.0678 6.54006 12.1281 6.12458 12.7206 5.81865C13.4086 5.46332 14.1029 4.87161 14.2509 4.51433C14.3275 4.32939 14.3297 4.20856 14.2607 3.97826C14.1401 3.57577 13.52 2.74039 12.7913 1.99891C11.9826 1.17589 11.7759 1.10633 11.1337 1.44097ZM0.0458114 4.43925C0.0458114 5.65884 0.0565484 6.15772 0.0696974 5.54797C0.0828464 4.93814 0.0828464 3.94029 0.0696974 3.33053C0.0565484 2.7207 0.0458114 3.21966 0.0458114 4.43925ZM3.2218 2.72965C2.87417 2.86946 2.24597 4.06945 1.99287 5.07709C1.88068 5.52369 1.87912 5.61208 1.97949 5.85226C2.2336 6.46039 3.39935 6.9539 5.1554 7.19688L5.51424 7.24652L5.55221 6.71823C5.61881 5.7901 5.9953 5.2923 6.87263 4.97237L7.35027 4.79824L7.00708 4.49449C5.45604 3.12202 3.96958 2.42901 3.2218 2.72965ZM17.4009 4.4815C16.2882 4.62497 15.3375 4.74425 15.2881 4.74642C15.2387 4.74868 15.1103 4.90048 15.0028 5.08379C14.8954 5.26717 14.631 5.58228 14.4153 5.78403C14.1995 5.98585 14.0371 6.15096 14.0544 6.15096C14.0717 6.15096 15.3656 5.9934 16.9297 5.80083C18.4939 5.60827 19.8088 5.45071 19.8516 5.45071C19.8971 5.45071 19.9295 5.19193 19.9295 4.82828V4.20584L19.6766 4.21315C19.5376 4.2172 18.5135 4.33795 17.4009 4.4815ZM7.90868 5.68755C6.81474 5.85405 6.46976 6.15173 6.46999 6.929C6.47022 7.54024 6.60148 7.93261 6.9085 8.23962L7.17599 8.50712L7.97022 8.4616C8.92955 8.40667 9.27765 8.31253 9.60505 8.01944C9.84835 7.80174 9.85364 7.7826 9.84781 7.14896C9.84096 6.41752 9.70208 6.00017 9.3995 5.80192C9.15682 5.64289 8.52201 5.59419 7.90868 5.68755ZM10.7995 7.59058C10.7119 8.22959 10.3268 8.77406 9.76043 9.05976C9.62342 9.12885 9.46586 9.18588 9.41031 9.18651C9.35468 9.18721 9.25945 9.21918 9.19868 9.25762C9.11053 9.31348 9.2151 9.52138 9.71647 10.2874C10.4479 11.4049 11.6044 13.3133 11.6044 13.4029C11.6044 13.5671 11.7624 13.4145 12.1424 12.8831C12.3712 12.5632 12.615 12.2857 12.6843 12.2663C12.7537 12.2468 13.1015 12.207 13.4573 12.1779C13.9916 12.1341 14.0963 12.1042 14.0588 12.0065C13.9761 11.791 13.1431 10.4029 12.6692 9.69107C12.2114 9.00336 10.918 7.24022 10.8713 7.24022C10.8583 7.24022 10.8259 7.39785 10.7995 7.59058ZM0.0469784 10.9359C0.0469784 12.6476 0.0572487 13.3368 0.0697752 12.4674C0.0823018 11.598 0.0823018 10.1975 0.0697752 9.35519C0.0571709 8.51295 0.0469006 9.22424 0.0469784 10.9359ZM5.19143 8.8167C4.5528 10.2742 3.57581 13.2424 3.69524 13.3618C3.71695 13.3835 4.05322 13.3517 4.44256 13.2911L5.1505 13.1809L5.68868 13.634C5.98472 13.8832 6.25517 14.0866 6.28972 14.0862C6.32434 14.0856 6.4717 13.6743 6.61728 13.172C6.76293 12.6696 7.10122 11.6196 7.36918 10.8387L7.85632 9.41875L7.53234 9.41829C7.01346 9.41759 6.63268 9.27349 6.27245 8.9415C6.08758 8.77111 5.87245 8.47623 5.79433 8.28631C5.71622 8.09646 5.63484 7.94132 5.61344 7.94171C5.59204 7.94202 5.40212 8.33579 5.19143 8.8167Z"
    //         fill="#FFA800"
    //       />
    //     </svg>
    //   ),
    // },
    {
      name: "Help and Support",
      href: links.faq,
      link: true,
      icon: (
        <svg
          width={20}
          height={25}
          viewBox="0 0 20 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.18721 0.40145C6.49224 0.662281 4.79317 1.50777 3.6595 2.65448C2.57094 3.75564 2.01913 4.96631 1.87363 6.57276C1.80428 7.33759 1.79362 7.36042 1.44986 7.48481C0.716479 7.74995 -0.00139796 8.82332 2.04437e-06 9.65244C0.000755891 10.0956 0.487741 11.0041 0.888464 11.3097C1.1522 11.5109 1.28176 11.7095 1.3257 11.9802C1.41088 12.5052 1.87525 13.0809 2.40897 13.3233C2.80388 13.5027 3.1486 13.5248 5.56899 13.527L8.28574 13.5294L8.4587 13.7933C8.67602 14.125 9.43407 14.4986 9.88971 14.4986C10.4016 14.4986 10.8883 14.258 11.2809 13.8109C11.5635 13.489 11.6292 13.3225 11.6292 12.928C11.6292 11.378 9.86936 10.6579 8.66525 11.7151C8.45816 11.897 8.25968 12.1615 8.22425 12.3029L8.15964 12.5601L5.61368 12.5597C3.26545 12.5594 3.04037 12.5428 2.71762 12.3459C2.2511 12.0615 2.27608 11.914 2.79074 11.914C3.52919 11.914 3.55223 11.8417 3.55223 9.53204V7.48858L3.2199 7.30507C2.88928 7.12264 2.88777 7.11779 2.93311 6.3619C3.06611 4.14581 5.06154 2.13357 7.7196 1.5347C8.87019 1.27559 11.3416 1.2954 12.4251 1.5725C13.6167 1.87727 14.6795 2.47216 15.5085 3.29848C16.3369 4.12416 16.7507 4.85087 16.9631 5.85305C17.1907 6.92771 17.1721 7.09216 16.7977 7.30507L16.4753 7.48858V9.53204C16.4753 11.9082 16.4785 11.9168 17.3714 11.9092C18.7235 11.8978 19.7425 11.0931 19.9751 9.85307C20.1381 8.98399 19.4819 7.8907 18.5484 7.4763C18.0939 7.27459 18.0907 7.2691 18.0907 6.70845C18.0907 3.99084 15.8158 1.42528 12.6649 0.589588C11.7484 0.346419 9.23171 0.240665 8.18721 0.40145ZM9.09839 3.29988C7.10974 3.57342 5.31484 4.82028 4.52696 6.47551C3.8934 7.80659 3.84494 9.07876 4.36499 10.7248L4.63853 11.5909H6.01139H7.38436L7.8609 11.1052C8.37125 10.5853 9.22353 10.1909 9.83673 10.1909C10.4602 10.1909 11.3005 10.5095 11.7511 10.9165C12.3703 11.476 12.6346 12.0474 12.6368 12.8315C12.6433 15.0511 9.96801 16.2708 8.14424 14.8797C7.87264 14.6725 7.65779 14.6064 7.2575 14.6068L6.72916 14.6074L7.05224 14.8758C7.22993 15.0235 7.7363 15.3262 8.17741 15.5484C8.9376 15.9313 9.03334 15.9524 10.0104 15.9524C10.9619 15.9524 11.0978 15.9247 11.7729 15.5923C14.0013 14.4953 15.9432 11.293 15.9343 8.73016C15.9289 7.21644 15.4955 6.19562 14.3777 5.06356C12.9974 3.66582 11.0841 3.02667 9.09839 3.29988ZM6.09787 17.4693C4.12247 17.9476 2.41953 19.4165 1.71877 21.2466C1.38708 22.1129 1.28542 23.9548 1.55443 24.2239C1.72265 24.3921 2.37505 24.4063 9.94701 24.4063C16.7994 24.4063 18.1912 24.3814 18.3626 24.2561C18.5416 24.1252 18.5648 23.9834 18.5429 23.1522C18.4978 21.4382 18.0347 20.341 16.864 19.1737C16.0274 18.3398 14.9951 17.7551 13.8412 17.4618C12.9519 17.2357 7.0391 17.2415 6.09787 17.4693Z"
            fill="#FFA800"
          />
        </svg>
      ),
    },
    {
      name: "Share Pexo App",
      link: false,
      href: links.default + links.user.referral,
      icon: (
        <svg
          width={20}
          height={21}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_8_1513)">
            <path
              d="M15.9167 19.9896C13.9167 19.9896 12.3334 18.4062 12.25 16.4063L6.16671 13.3229C5.50004 13.8229 4.83337 13.9896 4.00004 13.9896C2.00004 13.9896 0.333374 12.3229 0.333374 10.3229C0.333374 8.32292 2.00004 6.65625 4.00004 6.65625C4.75004 6.65625 5.50004 6.90625 6.16671 7.32292L12.25 4.23958C12.25 2.23958 13.9167 0.65625 15.9167 0.65625C17.9167 0.65625 19.5834 2.32292 19.5834 4.32292C19.5834 6.32292 17.9167 7.98958 15.9167 7.98958C15.1667 7.98958 14.4167 7.73958 13.75 7.32292L7.83337 10.4062L13.8334 13.4062C14.4167 12.9896 15.1667 12.7396 16 12.7396C18 12.7396 19.6667 14.4063 19.6667 16.4063C19.5834 18.3229 17.9167 19.9896 15.9167 19.9896Z"
              fill="#FFA800"
            />
          </g>
          <defs>
            <clipPath id="clip0_8_1513">
              <rect
                width={20}
                height={20}
                fill="white"
                transform="translate(0 0.40625)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
  ],
  depositLink = links.default + links.deposit;
